import { Suspense, type ReactNode } from 'react'
import { LoadingSpinner } from '@components/ui'

interface SuspenseWrapperProps {
  children: ReactNode
}

export function SuspenseWrapper({ children }: SuspenseWrapperProps) {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen bg-slate-950">
          <LoadingSpinner size="lg" className="text-sky-400" />
        </div>
      }
    >
      {children}
    </Suspense>
  )
}
